import React from 'react'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { LeadsApiClient } from 'utils/api/leadsApi'
import { useCallbackWithForceRefresh } from 'utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from 'utils/api/useFetch'

import { LeadNavigation } from '../Navigation/LeadNavigation'
import { LeadDemoAccountsTable } from './LeadDemoAccountsTable'
import { LeadTab } from './LeadSlug'
import { LeadWelcomeAccountsTable } from './LeadWelcomeAccountsTable/LeadWelcomeAccountsTable'

interface Props {
  data: LeadDetailsDto
  type: LeadTab.WELCOME_ACCOUNTS | LeadTab.DEMO_ACCOUNTS
}

const LeadDemoWelcomeAccountsPage: React.FC<Props> = ({ data, type }) => {
  const leadsApiClient = useApiClient(LeadsApiClient)

  const { callback, forceRefresh } = useCallbackWithForceRefresh(() => {
    if (type === LeadTab.DEMO_ACCOUNTS) {
      return leadsApiClient.getLeadDemoAccounts(data.id)
    }
    return leadsApiClient.getLeadWelcomeAccounts(data.id)
  }, [type, data.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: pageData, isLoading } = useFetchOne(callback)

  const handleChange = () => {
    forceRefresh()
  }

  return (
    <Loading isLoading={isLoading}>
      <LeadNavigation data={data} isEdit={false} tab={type} />
      {pageData &&
        (type === LeadTab.DEMO_ACCOUNTS ? (
          <LeadDemoAccountsTable data={pageData} />
        ) : (
          <LeadWelcomeAccountsTable data={pageData} onChange={handleChange} />
        ))}
    </Loading>
  )
}

export default LeadDemoWelcomeAccountsPage
